export default __webpack_public_path__ + "static/media/down-arrow-blue.b0ce22be.svg";